import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { select, Store } from '@ngrx/store';
import { IOption } from '../../../ui/interfaces/option';
import { IAppState } from '../../../interfaces/app-state';
import { IAppSettings } from '../../../interfaces/settings';
import { environment } from '../../../../environments/environment';
import * as SettingsActions from '../../../store/actions/app-settings.actions';
import { selectSettings } from '../../../store/reducers/app-settings.reducer';
import { SETTINGS0 } from '../../../../environments/settings';
import { ColorService } from '../../../shared/services/color.service';

const LAYOUTS: IOption[] = [
  {
    label: 'Vertical',
    value: 'vertical',
  },
  {
    label: 'Horizontal',
    value: 'horizontal',
  },
];

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  form: UntypedFormGroup;
  layouts: IOption[];
  defaultSettings: IAppSettings;
  settings: IAppSettings;
  downloadJsonHref: SafeUrl;

  constructor(
    private colorService: ColorService,
    private store: Store<IAppState>,
    private sanitizer: DomSanitizer,
    private router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    this.layouts = LAYOUTS;
    this.defaultSettings = environment.appSettings;

    this.initSettingsForm();
  }

  ngOnInit() {
    console.log('## init setting');
    this.store.pipe(select(selectSettings)).subscribe((st) => {
      if (st) {
        this.settings = { ...st, layout: this.getLayout() };

        this.updateSettingsForm(this.settings);
        this.downloadSettings(this.settings);
      }
    });
  }

  resetSettings(data: IAppSettings = this.defaultSettings) {
    this.store.dispatch(new SettingsActions.Reset());
    this.colorService.resetDefault();
    this.form.patchValue({
      boxed: data.boxed,
      layout: data.layout,
      topbarBg: data.topbarBg,
      topbarColor: data.topbarColor,
      sidebarBg: data.sidebarBg,
      sidebarBg2: data.sidebarBg2,
      sidebarColor: data.sidebarColor,
      sidebarAccentColor: data.sidebarAccentColor,
      sidebarAccentContrastColor: data.sidebarAccentContrastColor,
      headerFormBg: this.colorService.getHeaderFormBg(),
      titleHeaderFormColor: this.colorService.getTitleHeaderFormColor(),
    });
  }

  downloadSettings(settings: IAppSettings) {
    this.settings.headerFormBg = this.colorService.getHeaderFormBg();
    this.settings.titleHeaderFormColor = this.colorService.getTitleHeaderFormColor();
    const JSON_FILE = JSON.stringify(settings);
    const URI = this.sanitizer.bypassSecurityTrustUrl(
      `data:text/json;charset=UTF-8, ${encodeURIComponent(JSON_FILE)}`
    );

    this.downloadJsonHref = URI;
  }

  getLayout() {
    const url = this.router.url.split('/').filter(Boolean);
    return url[0];
  }

  // liste layout value in app store
  changeLayout(layout: string) {
    const url = this.router.url.split('/').filter((n) => n);

    url[0] = layout;

    const route = url.join('/');

    setTimeout(() => {
      this.router.navigate([route]);
    });
  }

  // liste boxed value in app store
  changeBoxed(boxed: boolean) {
    this.store.dispatch(new SettingsActions.Update({ boxed: boxed }));
  }

  changeHeaderFormBg(event) {
    this.colorService.setHeaderFormBg(event.color);
  }

  changeTitleHeaderFormColor(event) {
    this.colorService.setTitleHeaderFormColor(event.color);
  }

  // liste color in app store
  changeColor(value: any, name: string) {
    if(name === 'sidebarBg2') {
      this.colorService.setSidebarBg2(value.color);
    }
    this.store.dispatch(
      new SettingsActions.Update({
        [name]: value.color,
      })
    );
  }

  changeDoubleColor(value: any, name: string, contrastName: string): void {
    this.store.dispatch(
      new SettingsActions.Update({
        [name]: value.color,
        [contrastName]: value.contrast,
      })
    );
  }

  getNavbarName(bool: boolean) {
    return bool ? 'Sidebar' : 'Second navbar';
  }

  private initSettingsForm() {
    const data = this.defaultSettings;

    this.form = this.formBuilder.group({
      boxed: data.boxed,
      layout: data.layout,
      topbarBg: data.topbarBg,
      topbarColor: data.topbarColor,
      sidebarBg: data.sidebarBg,
      sidebarBg2: data.sidebarBg2,
      sidebarColor: data.sidebarColor,
      sidebarAccentColor: data.sidebarAccentColor,
      sidebarAccentContrastColor: data.sidebarAccentContrastColor,
      headerFormBg: this.colorService.getHeaderFormBg(),
      titleHeaderFormColor: this.colorService.getTitleHeaderFormColor()
    });
  }

  private updateSettingsForm(data: IAppSettings) {
    this.form.patchValue({
      boxed: data.boxed,
      layout: data.layout,
      topbarBg: data.topbarBg,
      topbarColor: data.topbarColor,
      sidebarBg: data.sidebarBg,
      sidebarBg2: data.sidebarBg2,
      sidebarColor: data.sidebarColor,
      sidebarAccentColor: data.sidebarAccentColor,
      sidebarAccentContrastColor: data.sidebarAccentContrastColor,
      headerFormBg: this.colorService.getHeaderFormBg(),
      titleHeaderFormColor: this.colorService.getTitleHeaderFormColor(),
    });

    /*this.form.valueChanges.pipe().subscribe((newData) => {
      if (data.layout !== newData.layout) {
        this.changeLayout(newData.layout);
        data.layout = newData.layout;
      }

      if (data.boxed !== newData.boxed) {
        this.changeBoxed(newData.boxed);
        data.boxed = newData.boxed;
      }
    });*/
  }
}
